import React from 'react'

export const EvianPrivacy = () => {
  return (
    <div>EvianPrivacy</div>
  )
}